export const products = {
  modal: {
    coderhouse: {
      url: 'https://www.coderhouse.com/alianzas/konzerta?utm_source=bumeran&utm_medium=alianzas&utm_campaign=panama',
      code: 'KONZERTACOD',
    },
  },
}
